import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home'
import TicketSearch from '../views/ticket-serach'
import Userinfo from '../views/user-info'
import Passenger from '../views/passenger'
import MyTicket from '../views/my-ticket'
import Order from '../views/order'
import AddPassanger from '../views/add-passenger'
import CheckOrder from '../views/check-order'
import BuyTicket from '../views/buy-ticket'
import AliPay from '../views/ali-pay'
import TikectList from '../views/order-list'
import OrderDetail from '../views/order-detail'
import PersonalTicket from '../views/personalTicket'
import PaySuccess from '../views/pay-success'
import RefundFlow from '../views/refund-flow'
import RescheduleFlow from '../views/reschedule-flow'
import RescheduleConfirm from '../views/reschedule-confirm'
import RescheduleSuccess from '../views/reschedule-success'
const routes = [
  {
    label: '首页',
    path: '/',
    name: 'home',
    component: Home,
    icon: 'icon-huochezhanxiao',
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    redirect: '/'
  },
  {
    label: '车票查询',
    path: '/ticketSearch',
    name: 'ticketSearch',
    component: TicketSearch,
    icon: 'icon-chaxun',
    meta: { requiresAuth: false }
  },
  {
    label: '用户信息',
    path: '/userInfo',
    name: 'userInfo',
    component: Userinfo,
    icon: 'icon-ic_account',
    meta: { requiresAuth: true }
  },
  {
    label: '人员信息',
    path: '/passenger',
    name: 'passenger',
    component: Passenger,
    icon: 'icon-renyuanfenbu',
    meta: { requiresAuth: true }
  },
  {
    label: '我的车票',
    path: '/myTicket',
    name: 'myTicket',
    component: MyTicket,
    icon: 'icon-dingdan',
    meta: { requiresAuth: true }
  },
  {
    label: '我的订单',
    path: '/order',
    name: 'order',
    component: Order,
    icon: 'icon-dingdan',
    meta: { requiresAuth: true }
  },
  {
    label: '添加乘车人',
    path: '/addPassenger',
    name: 'addPassenger',
    component: AddPassanger,
    icon: 'icon-icon-adduser',
    meta: { requiresAuth: true }
  },
  {
    label: '结算',
    path: '/checkOrder',
    name: 'checkOrder',
    component: CheckOrder,
    icon: 'icon-goumai',
    meta: { requiresAuth: true }
  },
  {
    label: '购票',
    path: '/buyTicket',
    name: 'buyTicket',
    component: BuyTicket,
    icon: 'icon-goumai',
    meta: { requiresAuth: true }
  },
  {
    label: '支付宝支付',
    path: '/aliPay',
    name: 'aliPay',
    component: AliPay,
    icon: 'icon-zhifubao0',
    meta: { requiresAuth: true }
  },
  {
    label: '订单列表',
    path: '/ticketList',
    name: 'ticketList',
    component: TikectList,
    icon: 'icon-zhifubao0',
    meta: { requiresAuth: true }
  },
  {
    label: '订单详情',
    path: '/orderDetail',
    name: 'orderDetail',
    component: OrderDetail,
    icon: 'icon-dingdan',
    meta: { requiresAuth: true }
  },
  {
    label: '本人车票',
    path: '/personalTicket',
    name: 'personalTicket',
    component: PersonalTicket,
    icon: 'icon-dingdan',
    meta: { requiresAuth: false }
  },
  {
    label: '支付成功',
    path: '/paySuccess',
    name: 'paySuccess',
    component: PaySuccess,
    icon: 'icon-zhifuchenggong',
    meta: { requiresAuth: false }
  },
  {
    label: '退票',
    path: '/refundFlow',
    name: 'refundFlow',
    component: RefundFlow,
    icon: 'icon-dingdan',
    meta: { requiresAuth: true }
  },
  {
    label: '改签',
    path: '/rescheduleFlow',
    name: 'rescheduleFlow',
    component: RescheduleFlow,
    icon: 'icon-dingdan',
    meta: { requiresAuth: true }
  },
  {
    path: '/rescheduleConfirm',
    name: 'rescheduleConfirm',
    component: RescheduleConfirm,
    meta: { requiresAuth: true }
  },
  {
    path: '/rescheduleSuccess',
    name: 'rescheduleSuccess',
    component: RescheduleSuccess,
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from) => {
  // 已由 App.vue 自动登录，此处不再拦截跳转
})

export { routes }

export default router
